import { gql, TypedDocumentNode } from "@apollo/client";

import { IntegrationsCount } from "types/generated";

export type IntegrationsCountData = {
  integrationsCount: Omit<IntegrationsCount, "__typename">;
};
export const GET_INTEGRATIONS_COUNT: TypedDocumentNode<IntegrationsCountData> = gql`
  query GetIntegrationsCount {
    integrationsCount {
      aws
      azure
      azureDevOps
      backstage
      bitbucketCloud
      bitbucketDatacenter
      github
      gitlab
      serviceNow
      slack
      vcsAgentPools
      webhooks
      ai
    }
  }
`;
